class AnchorLinks {
	constructor(el) {
		this.el = el;
		this.buffer = 100;
		this.isFixed = false;
		this.initScrollWatcher();
	}

	initScrollWatcher() {
		document.addEventListener('scroll', this.checkAnchorTop.bind(this));
	}

	checkAnchorTop() {
		const rect = this.el.getBoundingClientRect();

		if (rect.top <= this.buffer) {
			if (!this.isFixed) {
				this.el.classList.add('fixed-side');
				this.isFixed = true;
			}
		} else if (this.isFixed) {
			this.el.classList.remove('fixed-side');
			this.isFixed = false;
		}
	}
}

export default AnchorLinks;
